import angular from 'angular';
import workbenchRequirementsForm from './workbenchRequirementsForm';

export default angular
  .module('components.workbenchRequirementsForm', [])
  .component('workbenchRequirementsForm', workbenchRequirementsForm).name;
